import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { rovoAiProjectEntryPoint } from '@jira/project-create__project-template-select-v2/src/ui/layout/screens/category-overview/rovo-ai-project/rovoAiProjectEntryPoint.entrypoint.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type {
	RovoAiProjectSpotlightModalEntryPointProps,
	RovoAiProjectSpotlightNestedEntryPoints,
} from './RovoAiProjectSpotlightModal.entrypoint.types.tsx';

type RovoAiProjectSpotlightModalEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	RovoAiProjectSpotlightNestedEntryPoints,
	RovoAiProjectSpotlightModalEntryPointProps,
	Record<string, never>
>;

export const rovoAiProjectSpotlightModalEntryPoint: EntryPoint<
	RovoAiProjectSpotlightModalEntryPointComponent,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction<RovoAiProjectSpotlightModalEntryPointComponent>(
		/* webpackChunkName: "async-solcom-spotlight-modal" */ './RovoAiProjectSpotlightModal.tsx',
	),
	getPreloadProps: () => ({
		entryPoints: {
			rovoAiProjectEntryPoint: {
				entryPoint: rovoAiProjectEntryPoint,
				entryPointParams: {},
			},
		},
	}),
});
